import { useEffect } from 'react';

import { getBotChallengeToken, loadTurnstile } from '@restworld/data-services';

/**
 * Cloudflare Turnstile for the anonymous funnels. The Axios interceptor in `@restworld/data-services` already
 * attaches a token to every protected call, so most screens need nothing; this hook only warms the Cloudflare
 * script up on the pages where a protected call is coming (employer getting started, worker entry point), so the
 * first one does not wait for the download. `getToken(action)` is there for a call that does not go through the
 * shared Axios instance. Without `NEXT_PUBLIC_TURNSTILE_SITE_KEY` both are no-ops.
 */
export const useBotChallenge = () => {
  useEffect(() => {
    loadTurnstile();
  }, []);

  return { getToken: getBotChallengeToken };
};
